import { FeaturedDealsState } from "./types";

export const initialState: FeaturedDealsState = {
	selectedDealIndex: null
};
